<app-split-pane
  storageKey="split.guardrails"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    <app-split-pane-vertical storageKey="split.guardrails.left" [initialTopRatio]="0.7">
      <ng-container top>
        <app-chat [suggestions]="guardrailSuggestions" [context]="guardrailContext" placeholder="Ask about guardrails..."></app-chat>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="guardrails.chat"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.guardrails.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="page-workspace">
          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h2 class="h4 mb-1">Guard Rails</h2>
            <p class="text-muted mb-3">
              Define enforcement boundaries so releases stay safe and compliant.
            </p>
            <h3 class="h5 mb-3">Guard Rail Policy</h3>
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Policy tier</label>
                <select class="form-select" [(ngModel)]="guardrailsDraft.policyTier">
                  <option value="">Select tier...</option>
                  @for (option of policyTierOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Enforcement mode</label>
                <select class="form-select" [(ngModel)]="guardrailsDraft.enforcementMode">
                  <option value="">Select mode...</option>
                  @for (option of enforcementModeOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
              <div class="col-12">
                <label class="form-label">Release block notes</label>
                <textarea
                  class="form-control"
                  rows="3"
                  [(ngModel)]="guardrailsDraft.releaseBlockNotes"
                  placeholder="Describe checks that should block or gate deployments..."
                ></textarea>
              </div>
            </div>
            <div class="mt-3">
              <button class="btn btn-primary" type="button" [disabled]="applyingGuardrails" (click)="applyGuardrails()">
                @if (applyingGuardrails) {
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Applying...
                } @else {
                  Apply Guard Rails
                }
              </button>
            </div>
            @if (guardrailsError) {
              <div class="alert alert-danger mt-3 mb-0">{{ guardrailsError }}</div>
            }
            @if (guardrailsSuccess) {
              <div class="alert alert-success mt-3 mb-0">{{ guardrailsSuccess }}</div>
            }
          </section>

          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h3 class="h5 mb-3">Enforcement Summary</h3>
            @if (!hasAppliedGuardrails) {
              <div class="small text-muted">No policy applied yet. Apply guard rails to generate summary.</div>
            } @else {
              <div class="summary-grid">
                <article class="summary-card">
                  <div class="summary-label">Tier</div>
                  <div class="summary-value">{{ guardrailsDraft.policyTier }}</div>
                </article>
                <article class="summary-card">
                  <div class="summary-label">Mode</div>
                  <div class="summary-value">{{ guardrailsDraft.enforcementMode }}</div>
                </article>
                <article class="summary-card summary-card--full">
                  <div class="summary-label">Release notes</div>
                  <div class="summary-value">{{ guardrailsDraft.releaseBlockNotes.trim() || 'No notes provided.' }}</div>
                </article>
              </div>
            }
          </section>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="guardrails.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>
